export enum JobseekerPrivacyEnum{
    Public = 1,
    AvailableToAllCustomers = 2,
    Hidden = 3,
}